import * as React from 'react';

import type { SupplierTeamClient } from '@/api/supplier-team-client';
import { HttpSupplierTeamClient } from '@/api/supplier-team-client.http';

// =============================================================================
// supplier-team-client-context.tsx — Injection du SupplierTeamClient (DI seam, DBU §3.7, F4).
// =============================================================================
// Permet de substituer le client sans toucher l'UI. Par défaut : l'adaptateur HTTP RÉEL
// (HttpSupplierTeamClient) — le BACK équipe fournisseur est livré (F4). Câblé HTTP DÈS LE DÉPART
// (garde 09_stub_in_prod_guard : aucun défaut stub-en-prod). Les tests de composant injectent un
// StubSupplierTeamClient (double déterministe) via le provider.

/** Adaptateur par défaut : HTTP réel (chemins relatifs racine API, cookie de session fournisseur). */
const defaultSupplierTeamClient: SupplierTeamClient = new HttpSupplierTeamClient();

const SupplierTeamClientContext =
  React.createContext<SupplierTeamClient>(defaultSupplierTeamClient);

export interface SupplierTeamClientProviderProps {
  client?: SupplierTeamClient | undefined;
  children: React.ReactNode;
}

export function SupplierTeamClientProvider({
  client = defaultSupplierTeamClient,
  children,
}: SupplierTeamClientProviderProps): React.JSX.Element {
  return (
    <SupplierTeamClientContext.Provider value={client}>
      {children}
    </SupplierTeamClientContext.Provider>
  );
}

export function useSupplierTeamClient(): SupplierTeamClient {
  return React.useContext(SupplierTeamClientContext);
}
